import type { StudioUser } from "./types";

/** Shared auth user for the legacy StudioRoot shell (not React Router). */
let user: StudioUser | null = null;
const listeners = new Set<() => void>();

export function setStudioAuthUser(next: StudioUser | null) {
  user = next;
  for (const listener of listeners) listener();
}

export function getStudioAuthUser() {
  return user;
}

export function subscribeStudioAuth(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
